export default class UsersPrivilegeRevenues {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.revenuesAdd = false;
    this.revenuesRefund = false;
    this.revenuesView = false;
  }
  fillData(data) {
    this.revenuesAdd = data.revenuesAdd;
    this.revenuesRefund = data.revenuesRefund;
    this.revenuesView = data.revenuesView;
  }
}
